import axiosHttp from "./interceptor";

export const getDashboard = async () => {
	try {
		const response = await axiosHttp.get(`api/Dashboard/GetDashboard`);

		return response.data;
	} catch (error) {
		// emitToasterMsg("error", "Error", error.message);
	}
};
